import * as React from 'react';

import { ForeignTravel, defaultForeignTravel } from '../../../policy/policyAPI';

import ActivitiesForm from './ActivitiesForm';

interface Props {
	user: UserDetails;
	customerDetails: CustomerDemographicDetails;
	customerPolicy: CustomerPolicy;
	questionnaire: any;
	onQuestionnaireChange: (e: any) => void;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onCustomerDetailsChange: (e: any) => void;
	actions: any;
	history: any;
	match: any;
	className?: string;
}
class ActivitiesPage extends React.Component<Props> {

	saveForeignTravelList = (foreignTravelList: ForeignTravel[]) => {
		return this.props.actions
			.saveCustomerPolicyAnswer(this.props.customerPolicy.id, 'foreignTravelList', foreignTravelList);
	}

	onForeignTravelAdd = () => {
		const foreignTravelList: ForeignTravel[] = [...this.props.questionnaire.foreignTravelList, defaultForeignTravel];
		const questionnaire = {
			...this.props.questionnaire,
			foreignTravelList: foreignTravelList
		};

		this.props.actions.setQuestionnaire(questionnaire);
		this.saveForeignTravelList(foreignTravelList);
	}

	onForeignTravelBlur = (e?: any) => {
		// Save whole foreign travel list on blur
		return this.saveForeignTravelList(this.props.questionnaire.foreignTravelList);
	}

	onForeignTravelChange = (e: any, index: number) => {
		let value = e.target.value;
		if (e.target.type === 'radio') {
			if (value === 'true') {
				value = true;
			} else if (value === 'false') {
				value = false;
			}
		} else if (e.target.type === 'checkbox') {
			value = e.target.checked;
		}

		const foreignTravel = {
			...this.props.questionnaire.foreignTravelList[index],
			[e.target.name]: value
		};

		const foreignTravelList = [...this.props.questionnaire.foreignTravelList];
		foreignTravelList[index] = foreignTravel;
		const questionnaire = {
			...this.props.questionnaire,
			foreignTravelList: foreignTravelList
		};

		this.props.actions.setQuestionnaire(questionnaire);
	}

	onForeignTravelRemove = (index: number) => {
		const foreignTravelList = [...this.props.questionnaire.foreignTravelList];
		foreignTravelList.splice(index, 1);
		const questionnaire = {
			...this.props.questionnaire,
			foreignTravelList: foreignTravelList
		};

		this.props.actions.setQuestionnaire(questionnaire);
		this.saveForeignTravelList(foreignTravelList);
	}

	isNextDisabled = () => {
		if (this.props.questionnaire.abroad == null
			|| this.props.questionnaire.consumedAlcohol == null
			|| this.props.questionnaire.usedTobacco == null
			|| this.props.questionnaire.cannabis == null
			|| this.props.questionnaire.controlledSubstances == null
			|| this.props.questionnaire.substanceCounseling == null
		) {
			return true;
		}

		return false;
	}

	save = () => {
		return this.props.actions.saveUser(this.props.user)
		.then(() => {
			const customerDetails: CustomerDemographicDetails = {
				...this.props.customerDetails,
				customerId: this.props.user.id
			};
			return this.props.actions.saveCustomerDetails(customerDetails);
		});
	}

	back = () => {
		this.save().then(() =>
			this.props.history.push(`/quote/${this.props.match.params.workflow}/enrollment/lifestyle#6`)
		);
	}
	next = () => {
		this.props.actions.setQuestionnaireNavigationEnabled(false);
		this.save()
		.then(() => {		
			this.props.actions.setQuestionnaireNavigationEnabled(true);
			this.props.history.push(`/quote/${this.props.match.params.workflow}/enrollment/medical-history`);
		});
	}

	render() {
		return (
			<ActivitiesForm
				{...this.props}
				onForeignTravelAdd={this.onForeignTravelAdd}
				onForeignTravelBlur={this.onForeignTravelBlur}
				onForeignTravelChange={this.onForeignTravelChange}
				onForeignTravelRemove={this.onForeignTravelRemove}
				parentNext={this.next}
				parentPrev={this.back}
			/>
		);
	}
}

export default ActivitiesPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/ActivitiesPage.tsx